import React, { useState, useRef, useEffect, useCallback } from "react";
import VideoPlayer from "../components/VideoPlayer";
import LandscapeImg from "../assets/img/landscapevid.png";

const OPTIONS = [
  {
    label: "DOOH Landscape - Behind Counter DEMO - Apple",
    url: "https://ads-uncommonmedia.staging-adhese.com/e/stack/sl60",
  },
  {
    label: "DOOH Landscape - Behind Counter DEMO - Samsung",
    url: "https://ads-uncommonmedia.staging-adhese.com/e/stack/sl63",
  },
];

const Landscape = () => {
  const [endpoint, setEndpoint] = useState(OPTIONS[0].url);
  const [videos, setVideos] = useState([]);
  const [eventLog, setEventLog] = useState([]);
  const loggedSet = useRef(new Set());

  const CONFIG = {
    imageWidth: 1920,
    imageHeight: 1080,
    screenWidth: 331,
    screenHeight: 168,
    screenPosition: { x: 908, y: 386 },
    containerScale: 1,
  };

  const fetchAds = useCallback(async () => {
    try {
      const res = await fetch(endpoint);
      const data = await res.json();
      const videoUrls = [];

      data.ads.forEach((ad) => {
        ad.assets.forEach((asset) => {
          if (asset.data?.type === 501 && asset.data.url.endsWith(".mp4")) {
            videoUrls.push({
              url: asset.data.url,
              trackers: ad.eventtrackers || [],
            });
          }
        });
      });

      setVideos(videoUrls);
      setEventLog([]);
      loggedSet.current.clear();
    } catch (err) {
      console.error("Error fetching ads:", err);
      setVideos([]);
      setEventLog([]);
    }
  }, [endpoint]);

  const logEvent = (label, url) => {
    const key = `${label}:${url}`;
    if (!loggedSet.current.has(key)) {
      loggedSet.current.add(key);
      const time = new Date().toLocaleTimeString();
      setEventLog((prev) => [...prev, `[${time}] ${label}: ${url}`]);
    }
  };

  useEffect(() => {
    fetchAds();
  }, [fetchAds]);

  return (
    <div style={{ padding: "1rem", fontFamily: "Arial, sans-serif" }}>
      <h2>Landscape Layout</h2>

      <select
        value={endpoint}
        onChange={(e) => setEndpoint(e.target.value)}
        style={{ width: "70%", padding: "0.5rem", marginBottom: "1rem" }}
      >
        {OPTIONS.map((opt, i) => (
          <option key={i} value={opt.url}>
            {opt.label}
          </option>
        ))}
      </select>

      <button
        onClick={fetchAds}
        style={{ padding: "0.5rem 1rem", marginLeft: "1rem" }}
      >
        Reload Ads
      </button>

      <div
        style={{
          position: "relative",
          width: `${CONFIG.imageWidth * CONFIG.containerScale}px`,
          height: `${CONFIG.imageHeight * CONFIG.containerScale}px`,
          margin: "2rem auto",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: CONFIG.screenPosition.y,
            left: CONFIG.screenPosition.x,
            width: CONFIG.screenWidth,
            height: CONFIG.screenHeight,
            backgroundColor: "#000",
            overflow: "hidden",
            zIndex: 1,
            clipPath: "polygon(0% 9%, 96% 5%, 95% 98%, 0% 95%)",
          }}
        >
          {videos.length > 0 ? (
            <VideoPlayer
              videoObjects={videos}
              onLog={logEvent}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transform: "scale(1.01)",
                position: "absolute",
                top: 0,
                left: 0,
              }}
            />
          ) : (
            <div style={{ color: "#fff", padding: "30%", textAlign: "center" }}>
              No videos
            </div>
          )}
        </div>

        <img
          src={LandscapeImg}
          alt="Screen overlay"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: CONFIG.imageWidth,
            height: CONFIG.imageHeight,
            zIndex: 2,
            pointerEvents: "none",
          }}
        />
      </div>

      <div
        style={{
          backgroundColor: "#eee",
          padding: "1rem",
          borderRadius: "8px",
          height: "200px",
          overflowY: "auto",
        }}
      >
        <strong>Event Log:</strong>
        <ul style={{ listStyleType: "none", padding: 0 }}>
          {eventLog.map((log, i) => (
            <li key={i}>{log}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Landscape;
